import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';
import { Plus, Trash2 } from 'lucide-react';
interface GoalFormData {
  processorName: string;
  ctcGoal: string;
}
interface GoalSettingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (goals: GoalFormData[]) => void;
}
export function GoalSettingModal({
  isOpen,
  onClose,
  onSave
}: GoalSettingModalProps) {
  const [goals, setGoals] = useState<GoalFormData[]>([{
    processorName: '',
    ctcGoal: ''
  }]);
  const handleAddRow = () => {
    setGoals([...goals, {
      processorName: '',
      ctcGoal: ''
    }]);
  };
  const handleRemoveRow = (index: number) => {
    if (goals.length > 1) {
      setGoals(goals.filter((_, i) => i !== index));
    }
  };
  const handleChange = (index: number, field: keyof GoalFormData, value: string) => {
    const newGoals = [...goals];
    newGoals[index][field] = value;
    setGoals(newGoals);
  };
  const handleSave = () => {
    const validGoals = goals.filter(g => g.processorName && g.ctcGoal);
    if (validGoals.length > 0) {
      onSave(validGoals);
      onClose();
      // Reset form
      setGoals([{
        processorName: '',
        ctcGoal: ''
      }]);
    }
  };
  const handleCancel = () => {
    onClose();
    // Reset form
    setGoals([{
      processorName: '',
      ctcGoal: ''
    }]);
  };
  return <Modal isOpen={isOpen} onClose={handleCancel} title="Set Processor Goals" description="Add monthly CTC (Clear to Close) goals for processors" size="md" footer={<>
          <Button variant="outline" onClick={handleCancel} data-id="element-85">
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave} data-id="element-86">
            Save Goals
          </Button>
        </>} data-id="element-84">
      <div className="space-y-4" data-id="element-87">
        <div className="grid grid-cols-12 gap-3 text-xs font-medium text-slate-500 uppercase tracking-wider px-2" data-id="element-88">
          <div className="col-span-7" data-id="element-89">Processor Name</div>
          <div className="col-span-4" data-id="element-90">CTC Goal</div>
          <div className="col-span-1" data-id="element-91"></div>
        </div>

        {goals.map((goal, index) => <div key={index} className="grid grid-cols-12 gap-3 items-center" data-id="element-92">
            <div className="col-span-7" data-id="element-93">
              <input type="text" placeholder="Enter processor name" value={goal.processorName} onChange={e => handleChange(index, 'processorName', e.target.value)} className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-94" />
            </div>
            <div className="col-span-4" data-id="element-95">
              <input type="number" placeholder="0" min="0" value={goal.ctcGoal} onChange={e => handleChange(index, 'ctcGoal', e.target.value)} className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-96" />
            </div>
            <div className="col-span-1" data-id="element-97">
              {goals.length > 1 && <button onClick={() => handleRemoveRow(index)} className="text-red-500 hover:text-red-700 p-2" data-id="element-98">
                  <Trash2 className="w-4 h-4" data-id="element-99" />
                </button>}
            </div>
          </div>)}

        <Button variant="outline" size="sm" onClick={handleAddRow} className="w-full" data-id="element-100">
          <Plus className="w-4 h-4 mr-2" data-id="element-101" />
          Add Another Processor
        </Button>
      </div>
    </Modal>;
}